// imove-branch: 检查登录是否成功

export default async function(ctx) {
  const { status } = ctx.getPipe();
  if (status === 'success') {
    return true;
  }
  return false;
}